<template>
  <v-btn text @click="clicked">
    <v-icon :large="large">{{ icon }}</v-icon>
    <span>{{ text }}</span>
  </v-btn>
</template>

<script>
export default {
  name: 'IconBtn',
  props: {
    icon: String,
    text: String,
    large: Boolean,
  },
  methods: {
    clicked() {
      this.$emit('btn-click');
    },
  },
};
</script>
